import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarCursorIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.2 15.88L6.08001 0.759979C5.71001 0.369979 4.99001 0.659979 5.01001 1.19998V22.8C4.99001 23.36 5.75001 23.65 6.10001 23.21L11.64 16.94H20.75C21.29 16.96 21.59 16.24 21.19 15.87L21.2 15.88Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarCursorIcon.displayName = 'ToolbarCursorIcon';
